import { render, staticRenderFns } from "./fibre.vue?vue&type=template&id=f586aeaa&scoped=true&"
import script from "./fibre.vue?vue&type=script&lang=js&"
export * from "./fibre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f586aeaa",
  null
  
)

export default component.exports